import { inject } from '@angular/core';
import { Router } from '@angular/router';
import type { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

// Hoy AuthService arranca con un usuario quemado, así que isAuthenticated() siempre es true —
// el guard igual queda con la forma final: cuando exista JWT real, isAuthenticated() reflejará
// si hay un accessToken vigente en memoria y este guard no cambia.
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/auth/login']);
};
